import React, { FC, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { selectToken } from "../../store/reducers/auth";
import { ROUTES } from "../../routes";
import {
  useAcceptContactLinkMutation,
  useGetContactLinkQuery,
} from "../../store/services/contacts";
import { LinkExpiredPage } from "../Static";
import { toastError, toastSuccess } from "../../utils/toasts";

export const ContactLinkConfirmation: FC = () => {
  let { id } = useParams();
  const { data: contactLink, isLoading } = useGetContactLinkQuery(id || "");
  const token = useSelector(selectToken);
  const [accepted, setAccepted] = useState(false);

  const [acceptContactLink, { isLoading: isAccepting }] =
    useAcceptContactLinkMutation();

  if (isLoading || isAccepting) {
    return <></>;
  }

  if (!contactLink || contactLink.is_expired) {
    return <LinkExpiredPage />;
  }

  if (!token) {
    if (contactLink.user_with_email_exists) {
      return (
        <Navigate
          to={ROUTES.AUTH_LOGIN}
          state={{ from: { pathname: ROUTES.CONTACTS } }}
        />
      );
    }

    return (
      <Navigate
        to={ROUTES.AUTH_SIGNUP_DEFAULT}
        state={{ from: { pathname: ROUTES.CONTACTS } }}
      />
    );
  }

  if (!accepted) {
    setAccepted(true);

    acceptContactLink(contactLink)
      .unwrap()
      .then(() =>
        toastSuccess(`Invite from ${contactLink.from_user_name} accepted`)
      )
      .catch(({ data: [msg] }) => toastError(msg));

    return <></>;
  } else {
    return (
      <>
        <Navigate to={ROUTES.CONTACTS} />
      </>
    );
  }
};
